import { __assign } from 'tslib';
import { useContext, useReducer, useRef, useEffect, useState } from 'react';
import { getApolloContext, QueryData, MutationData, SubscriptionData } from '@apollo/react-common';
export { ApolloProvider } from '@apollo/react-common';

function useQuery(query, props) {
  var context = useContext(getApolloContext());

  var _a = useReducer(function (x) {
    return x + 1;
  }, 0),
      _ignored = _a[0],
      forceUpdate = _a[1];

  var newProps = props ? __assign({}, props, {
    query: query
  }) : {
    query: query
  };
  var queryDataRef = useRef(new QueryData({
    props: newProps,
    context: context,
    forceUpdate: forceUpdate
  }));
  var queryData = queryDataRef.current;
  queryData.props = newProps;
  queryData.context = context;
  useEffect(function () {
    return queryData.afterExecute();
  });
  return queryData.execute();
}

function useMutation(mutation, props) {
  var context = useContext(getApolloContext());

  var _a = useState({
    called: false,
    loading: false
  }),
      result = _a[0],
      setResult = _a[1];

  var newProps = props ? __assign({}, props, {
    mutation: mutation
  }) : {
    mutation: mutation
  };
  var mutationDataRef = useRef(new MutationData({
    props: newProps,
    context: context,
    result: result,
    setResult: setResult
  }));
  var mutationData = mutationDataRef.current;
  mutationData.props = newProps;
  mutationData.context = context;
  useEffect(function () {
    return mutationData.afterExecute();
  });
  return [function (options) {
    return mutationData.execute(options);
  }, result];
}

function useSubscription(subscription, props) {
  var context = useContext(getApolloContext());

  var _a = useState({
    loading: true,
    error: undefined,
    data: undefined
  }),
      result = _a[0],
      setResult = _a[1];

  var newProps = props ? __assign({}, props, {
    subscription: subscription
  }) : {
    subscription: subscription
  };
  var subscriptionDataRef = useRef(new SubscriptionData({
    props: newProps,
    context: context,
    setResult: setResult
  }));
  var subscriptionData = subscriptionDataRef.current;
  subscriptionData.props = newProps;
  subscriptionData.context = context;
  useEffect(function () {
    return subscriptionData.afterExecute();
  });
  return subscriptionData.execute(result);
}

export { useMutation, useQuery, useSubscription };